import { unwrapResult } from "@reduxjs/toolkit";
import { Col, Modal, Row, Table } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useAppDispatch } from "../../app/hooks";
import { ThemeContext } from "../../theme/theme";
import { getFactoryDetailAsync } from "./FactorySlice";
import styles from "./Factory.module.css";

export const FactoryDetailModal = (props: {
  osId?: any;
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}) => {
  const dispatch = useAppDispatch();

  const theme = useContext(ThemeContext);

  const [detail, setDetail] = useState<any>();

  const [list, setList] = useState<any>();

  useEffect(() => {
    if (props.osId) {
      dispatch(getFactoryDetailAsync(props.osId))
        .then(unwrapResult)
        .then((d: any) => {
          setDetail(d);
          setList(d.list);
        })
        .catch(() => {
          // do nothing
        });
    } else {
      setDetail(undefined);
    }
  }, [dispatch, props.osId]);

  const labelStyle = {
    style: {
      color: theme.tc3,
      fontSize: "1rem",
      textAlign: "left",
      marginBottom: 15,
    } as React.CSSProperties,
  };

  const valueStyle = {
    flex: 1,
    style: {
      color: theme.tc1,
      fontSize: "1rem",
      marginBottom: 4,
    } as React.CSSProperties,
  };

  return (
    <>
      <Modal
        className={styles.modal}
        width={960}
        title='预警规则'
        footer={null}
        visible={props.visible}
        onOk={() => {
          props.onOk()
        }}
        onCancel={() => {
          props.onCancel()
        }}
      >
        <Row gutter={20}>
          <Col span={12}>
            <Row>
              <Col {...labelStyle}>卫健委(局)名称：</Col>
              <Col {...valueStyle}>{detail?.osName}</Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col {...labelStyle}>所在辖区：</Col>
              <Col {...valueStyle}>{detail?.fullPath}</Col>
            </Row>
          </Col>
        </Row>
        <Table
          pagination={false}
          size='small'
          bordered
          dataSource={list}
          rowKey={(t: any) => t.id}
          columns={[
            {
              title: '序号',
              dataIndex: 'no',
              align: 'center',
              width: '4rem',
              key: 'no',
              render: (_1, _2, i) => `${i + 1}`,
            },
            {
              title: '规则名称',
              dataIndex: 'crName',
              align: 'center',
              key: 'crName',
            },
            {
              title: '主项编码',
              dataIndex: 'mainCode',
              align: 'center',
              key: 'mainCode',
            },
            {
              title: '子项编码',
              dataIndex: 'subCode',
              align: 'center',
              key: 'subCode',
            },
            {
              title: '上传时间',
              dataIndex: 'uploadTime',
              align: 'center',
              key: 'uploadTime',
            },
          ]}
        ></Table>
      </Modal>
    </>
  )
};
